var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.6202 8.7C19.5802 4.07 15.5402 2 12.0002 2C12.0002 2 12.0002 2 11.9902 2C8.46024 2 4.43024 4.07 3.38024 8.69C2.20024 13.85 5.36024 18.22 8.22024 20.98C9.28024 22 10.6402 22.51 12.0002 22.51C13.3602 22.51 14.7202 22 15.7702 20.98C18.6302 18.22 21.7902 13.86 20.6202 8.7Z",
    fill: "#D77910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 10.25H12.75V8.25C12.75 7.84 12.41 7.5 12 7.5C11.59 7.5 11.25 7.84 11.25 8.25V10.25H9.25C8.84 10.25 8.5 10.59 8.5 11C8.5 11.41 8.84 11.75 9.25 11.75H11.25V13.75C11.25 14.16 11.59 14.5 12 14.5C12.41 14.5 12.75 14.16 12.75 13.75V11.75H14.75C15.16 11.75 15.5 11.41 15.5 11C15.5 10.59 15.16 10.25 14.75 10.25Z",
    fill: "#D77910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationAdd);
export default __webpack_public_path__ + "static/media/location-add.2b46648f3e9dafc84c2624b4af9ffcc7.svg";
export { ForwardRef as ReactComponent };